import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const FolderIcon = ({ color = '#B5BCBD', size = 40, ...props }) => (
  <svg
    width={size}
    viewBox="0 0 51 44"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.167 0c1.336 0 2.598.632 3.4 1.702l1.7 2.273a4.255 4.255 0 0 0 3.4 1.702H46.75A4.255 4.255 0 0 1 51 9.935v29.807A4.255 4.255 0 0 1 46.75 44H4.25A4.255 4.255 0 0 1 0 39.742V4.258A4.255 4.255 0 0 1 4.25 0h9.917z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

FolderIcon.propTypes = propTypes;

export default FolderIcon;
